import { ActionIcon, Tooltip } from '@mantine/core'
import { useNavigate, useParams } from '@tanstack/react-router'
import { TbCalendarPlus } from 'react-icons/tb'
import { useTranslation } from 'react-i18next'

export function AddIntervalDriveButton({
  vehicleId,
  intervalStart,
  intervalEnd,
}: {
  vehicleId: string
  intervalStart: string
  intervalEnd: string
}) {
  const { t } = useTranslation('scheduling')
  const navigate = useNavigate()
  const { startDate, endDate } = useParams({ from: '/scheduling/$startDate/$endDate' })

  return (
    <Tooltip label={t('addDrive')}>
      <ActionIcon
        variant="subtle"
        size="sm"
        aria-label={t('addDrive')}
        onClick={() =>
          // The interval goes to the search, the path keeps the page's view range
          navigate({
            to: '/scheduling/$startDate/$endDate/drive/$action/$id',
            params: { startDate, endDate, action: 'new', id: vehicleId },
            search: { intervalStart, intervalEnd },
          })
        }
      >
        <TbCalendarPlus />
      </ActionIcon>
    </Tooltip>
  )
}
